class CompleteTheSet extends HTMLElement {
  connectedCallback () {
    this.defaultTitle = this.dataset.relatedProductTitle
    this.titleEl = this.querySelector('[data-el="completetheset.title"]')
    this.titleContainerEl = this.querySelector('[data-el="completetheset.titleContainer"]')

    this.setupHoverEvents()
    this.setupScrollTitle()

    window.addEventListener('resize', this.setupScrollTitle.bind(this))
  }

  disconnectedCallback () {
    this.scrollTitleObserver?.disconnect()
  }

  setupHoverEvents () {
    const productEls = this.querySelectorAll('[data-el="completetheset.product"]')

    productEls.forEach(el => {
      el.addEventListener('mouseenter', () => {
        this.titleEl.textContent = el.dataset.productTitle
        this.titleContainerEl.classList.add('prd-RelatedProducts_Selected-visible')
      })

      el.addEventListener('mouseleave', () => {
        this.titleEl.textContent = this.defaultTitle
        this.titleContainerEl.classList.remove('prd-RelatedProducts_Selected-visible')
      })
    })
  }

  setupScrollTitle () {
    if (this.scrollTitleObserver) {
      this.scrollTitleObserver.disconnect()
      this.scrollTitleObserver = null
    }

    if (!window.BAO.mediaBreakpoints.isXsViewport) return

    const container = this.querySelector('.prd-RelatedProducts_Container')
    if (!container) return

    const productEls = this.querySelectorAll('[data-el="completetheset.product"]')
    if (!productEls.length) return

    const visibleEls = new Set()

    this.scrollTitleObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            visibleEls.add(entry.target)
          } else {
            visibleEls.delete(entry.target)
          }
        })

        const activeEl = [...productEls].find(el => visibleEls.has(el))

        if (!activeEl) {
          this.titleEl.textContent = this.defaultTitle
          this.titleContainerEl.classList.remove('prd-RelatedProducts_Selected-visible')
          return
        }

        this.titleEl.textContent = activeEl.dataset.productTitle
        this.titleContainerEl.classList.add('prd-RelatedProducts_Selected-visible')

        productEls.forEach(el => el.classList.remove('prd-RelatedProducts_Link-active'))

        activeEl.classList.add('prd-RelatedProducts_Link-active')
      },
      {
        root: container,
        rootMargin: '0px -50% 0px -20px',
        threshold: 0
      }
    )

    productEls.forEach(el => this.scrollTitleObserver.observe(el))
  }
}

if (!customElements.get('complete-the-set')) {
  customElements.define('complete-the-set', CompleteTheSet)
}
